import mitt from 'mitt';

const fetchEmitter = mitt();

export default fetchEmitter;
